module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/icon_staff-9e7af7ea88bd57809bc1190376855077.png";